/*
 * @Descripttion:
 * @Author: etong
 * @Date: 2023-09-26 13:50:41
 * @LastEditors: your name
 * @LastEditTime: 2023-10-25 14:13:28
 */
// 货品
const map = {
  brandGoods: () => import('@/views/product/BrandGoods'),
  brandFiles: () => import('@/views/product/BrandFiles'),
  productList: () => import('@/views/product/ProductList'),
  productPriceList: () => import('@/views/product/ProductPriceList'),
  libraryAgeQuery: () => import('@/views/product/LibraryAgeQuery'), // 库龄查询  批次管理
  classifyManage: () => import('@/views/product/ClassifyManage'),
  productGroupPrice: () => import('@/views/product/ProductGroupPrice'),
  brandList: () => import('@/views/product/goodsFile/brandList'), // 商品品牌
  brandDetail: () => import('@/views/product/goodsFile/brandDetail'), // 品牌详情
  changeOrderList: () => import('@/views/product/goodsFile/changeOrderList'), // 变更单列表
  changeOrderDetail: () => import('@/views/product/goodsFile/changeOrderDetail'), // 变更单列表
  spuList: () => import('@/views/product/goodsFile/spuList'), // spu列表
  spuDetail: () => import('@/views/product/goodsFile/spuDetail'), // spu详情
  skuList: () => import('@/views/product/goodsFile/skuList'), // spu列表
  skuDetail: () => import('@/views/product/goodsFile/skuDetail'), // spu详情
  productSeriesList: () => import('@/views/product/goodsFile/productSeriesList'), // 产品系列列表
  productSeriesDetail: () => import('@/views/product/goodsFile/productSeriesDetail'), // 产品系列详情
  materialList: () => import('@/views/product/goodsFile/materialList'), // 物料列表
  commonMasterDetail: () => import('@/views/product/goodsFile/materialDetail'), // 主数据通用详情
  materialDetail: () => import('@/views/product/goodsFile/materialDetail'), // 物料详情
  portList: () => import('@/views/product/PortList'), // 接口管理
  PlatformApiManagementDetail: () => import('@/views/product/components/PlatformApiManagementDetail'), // API管理详情
  distributeList: () => import('@/views/product/DistributeList'), // 分发列表
  skuAuthorityList: () => import('@/views/product/goodsFile/skuAuthorityList'), // spu详情
  skuAuthorityDetail: () => import('@/views/product/goodsFile/skuAuthorityDetail'), // spu详情
  AlipayAccountConfig: () => import('@/views/product/AlipayAccountConfig/Detail'), // 支付宝账号配置
  InciChangeManageList: () => import('@/views/product/INCI/index'), // INCI变更管理
  InciChangeManageDetail: () => import('@/views/product/INCI/Detail') // INCI变更管理
}

export default map
